module.exports = __webpack_public_path__ + "065448779096e2b726157d55acb4a317.svg";